
import { Dossier } from "@/models/dossier";
import { User } from "@/models/user";
import { CompanyService } from "@/services";
import { IMoveUserDataSetting } from "@/services/company-dossier-service";
import Vue from "vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			sourceCompanyUsers: [] as User[],
			targetCompanyUsers: [] as User[]
		};
	},
	props: {
		sourceDossier: {
			type: Object as ()=>Dossier,
			required: true
		},
		targetDossier: {
			type: Object as ()=>Dossier,
			required: true
		},
		moveUserSettings: {
			type: Array as ()=>IMoveUserDataSetting[],
			required: true
		},
	},
	computed: {
		sourceUserItems():ISelectItem<number>[]{
			return this.sourceCompanyUsers.map(u=>{
				return {
					value: u.id,
					text: u.getUserString()
				};
			});
		},
		targetUserItems():ISelectItem<number>[]{
			return this.targetCompanyUsers.map(u=>{
				return {
					value: u.id,
					text: u.getUserString()
				};
			});
		}
	},
	methods: {
		addEntry(){
			this.moveUserSettings.push({
				fromUserId: 0,
				toUserId: 0
			});
		},
		removeItem(i:number){
			this.moveUserSettings.splice(i,1);
		}
	},
	async mounted(){
		let sourceCompany = await CompanyService.getCompany(this.sourceDossier.companyId);
		this.sourceCompanyUsers = sourceCompany.users;
		let targetCompany = await CompanyService.getCompany(this.targetDossier.companyId);
		this.targetCompanyUsers = targetCompany.users;
	}
});

